import React, { useEffect, useState } from 'react';
import BookCard from '../../../Components/Macro/BookCard/BookCard';
import { useBooks } from "./BookState";
import orn from './../../../assets/images/ornament.svg';
import { Form, Row, Col, Pagination, Card } from 'react-bootstrap';
import axios from 'axios';

function Books() {
    const [filters, setFilters] = useState({
        category: 0,
        author: 0,
        year: '',
        language: 0
    });
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(12);
    const [totalItems, setTotalItems] = useState(0);
    const [lastPage, setLastPage] = useState(1);
    const [languages, setLanguages] = useState([]);

    const { books, getBooks, getCats, getAuthors, cats, authors } = useBooks();
    const [bks, setBks] = useState([]);

    useEffect(() => {
        getCats();
        getAuthors();
        fetchLanguages();
        fetchBooks();
        axios.get('til').then(res => {
            if (res.status === 200) {
                setLanguages(res.data);
            }
        })
    }, [currentPage, perPage]);

    useEffect(() => {
        fetchBooks();
    }, [filters]);

    const fetchLanguages = async () => {
        try {
            const response = await axios.get('languages');
            if (response.status === 200) {
                setLanguages(response.data);
            }
        } catch (error) {
            console.error('Tillarni yuklashda xatolik:', error);
        }
    };

    const fetchBooks = async () => {
        try {
            const params = new URLSearchParams({
                page: currentPage,
                per_page: perPage,
                category: filters.category,
                author: filters.author,
                year: filters.year,
                language: filters.language
            });

            const response = await axios.get(`books?${params.toString()}`);
            if (response.status === 200) {
                setBks(response.data.data);
                setTotalItems(response.data.total);
                setLastPage(response.data.last_page);
            }
        } catch (error) {
            console.error('Kitoblarni yuklashda xatolik:', error);
        }
    };

    const handleFilterChange = (name, value) => {
        setFilters(prev => ({
            ...prev,
            [name]: value
        }));
        setCurrentPage(1);
    };

    const handleYearChange = (e) => {
        const value = e.target.value;
        // Faqat raqamlar va bo'sh qiymatga ruxsat berish
        if (value === '' || (/^\d{0,4}$/.test(value) && parseInt(value) <= new Date().getFullYear())) {
            handleFilterChange('year', value);
        }
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const renderPagination = () => {
        let items = [];
        for (let number = 1; number <= lastPage; number++) {
            items.push(
                <Pagination.Item
                    key={number}
                    active={number === currentPage}
                    onClick={() => handlePageChange(number)}
                >
                    {number}
                </Pagination.Item>
            );
        }
        return (
            <Pagination className="justify-content-center mt-4">
                <Pagination.Prev
                    disabled={currentPage === 1}
                    onClick={() => handlePageChange(currentPage - 1)}
                />
                {items}
                <Pagination.Next
                    disabled={currentPage === lastPage}
                    onClick={() => handlePageChange(currentPage + 1)}
                />
            </Pagination>
        );
    };

    const renderFilterSidebar = () => (
        <Card className="p-3" style={{ height: '100%', backgroundColor: '#ffffffba', backdropFilter: 'blur(5px)' }}>
            <h5 className="mb-3">Filtrlar</h5>

            <Form.Group className="mb-3">
                <Form.Label>Kategoriya</Form.Label>
                <Form.Select
                    value={filters.category}
                    onChange={(e) => handleFilterChange('category', Number(e.target.value))}
                >
                    <option value={0}>Barcha kategoriyalar</option>
                    {cats.map(i => <option key={i.id} value={i.id}>{i.name}</option>)}
                </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
                <Form.Label>Muallif</Form.Label>
                <Form.Select
                    value={filters.author}
                    onChange={(e) => handleFilterChange('author', Number(e.target.value))}
                >
                    <option value={0}>Barcha mualliflar</option>
                    {authors.map(i => <option key={i.id} value={i.id}>{i.fullname}</option>)}
                </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
                <Form.Label>Til</Form.Label>
                <Form.Select
                    value={filters.language}
                    onChange={(e) => handleFilterChange('language', Number(e.target.value))}
                >
                    <option value={0}>Barcha tillar</option>
                    {languages.map(lang => (
                        <option key={lang.id} value={lang.id}>{lang.til}</option>
                    ))}
                </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
                <Form.Label>Chop etilgan yili</Form.Label>
                <Form.Control
                    type="text"
                    placeholder="Yilni kiriting"
                    value={filters.year}
                    onChange={handleYearChange}
                />
            </Form.Group>
        </Card>
    );

    return (
        <>
            <div className="page-intro" style={{
                backgroundImage: 'url(' + orn + ')',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                backgroundSize: 'cover',
            }}>
                <h1>O'zingizni qiziqtirgan kitobni toping</h1>
            </div>

            <Row className="mt-4">
                <Col md={3}>
                    {renderFilterSidebar()}
                </Col>
                <Col md={9}>
                    <Row>
                        {bks.map(book => (
                            <Col key={book.id} md={4} className='mb-3'>
                                <BookCard book={book} />
                            </Col>
                        ))}
                    </Row>
                    {renderPagination()}
                </Col>
            </Row>
        </>
    );
}

export default Books;